export default __webpack_public_path__ + "static/media/brand_05.da9f543b.png";